import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SipConditionGroupApiService {

  constructor(private http: HttpClient) {}

  readonly sipConditionGroupUrl: string = 'sipCondition/group';
  readonly sipConditionTemplateUrl: string = 'sipCondition/templates';

  getSipConditionGroups(): Observable<any> {
    return this.http.get(this.sipConditionGroupUrl);
  }

  getSipConditionTemplate(): Observable<any> {
    return this.http.get(this.sipConditionTemplateUrl);
  }

  getSipConditionGroup(sipConditionGroup): Observable<any> {
    return this.http.get(`${this.sipConditionGroupUrl}/${sipConditionGroup}`);
  }

  addSipConditionGroup(sipConditionGroup): Observable<any> {
    return this.http.post(this.sipConditionGroupUrl, sipConditionGroup);
  }

  editSipConditionGroup(sipConditionGroup, sipConditionGroupId): Observable<any> {
    return this.http.put(`${this.sipConditionGroupUrl}/${sipConditionGroupId}`, sipConditionGroup);
  }

  deleteSipConditionGroup(sipConditionGroupId): Observable<any> {
    return this.http.delete(`${this.sipConditionGroupUrl}/${sipConditionGroupId}`);
  }
}
